import React from 'react';
import _ from 'lodash';
import $ from 'jquery';

import AUnits from './all_units/aUnitsCOmponent';
import AUFilter from './all_units_filter/aUFilterComponent';
import Alertbox from './alert/alertboxComponent';

import {
  decodeHtmlData,
  cleanArrToCompare,
  hasDisciplinesPlus,
  hasDegrees,
  hasClassification,
  hasOffering,
  hasTerm,
  filterAllUnits,
  getPreSelected } from './../mixin/mixin';

import reducer from '../reducer/reducer';

import {
  $setFilterContentHeight,
  $setEqualHeight,
  $fetchData,
  $changeZIndex
} from './../mixin/mixin-jquery';

class AppAllUnits extends React.Component {
  constructor(props) {
    super();

    // for matching
    this._hasDisciplinesPlus = hasDisciplinesPlus.bind(this);
    this._hasDegrees = hasDegrees.bind(this);
    this._hasClassification = hasClassification.bind(this);
    this._hasTerm = hasTerm.bind(this);
    this._hasOffering = hasOffering.bind(this);

    // for filtering
    this._filterAllUnits = filterAllUnits.bind(this);

    // reducer
    this._reducer = reducer.bind(this);

    // compare
    this._doComparison = this._doComparison.bind(this);
    this.clearComparison = this.clearComparison.bind(this);

    // alert box
    this._openAlertbox = this._openAlertbox.bind(this);

    // others
    this._decodeHtmlData = decodeHtmlData.bind(this);
    this._cleanArrToCompare = cleanArrToCompare.bind(this);
    this._getPreSelected = getPreSelected.bind(this);

    // pass to children and change state purpose
    this.dispatchReducer = this.dispatchReducer.bind(this);

    // jquery
    this._$changeZIndex = $changeZIndex.bind(this);

    let unitsData = props.data.units || {};

    this.state = {
      data:            props.data,
      options:         props.options,
      degrees:         props.data.degrees,
      disciplines:     props.data.disciplines,
      units:           unitsData.units || [],
      classifications: ['All', 'Fundamental', 'Intermediate', 'Advanced'],
      offerings:       props.data.offerings.filter(function(item) {
        return item.status !== 'Inactive';
      }),

      avaiDegrees:    props.data.degrees,

      currOffering:       props.data.offerings.map(function(item) {
        return item.trimester;
      }),
      currClassification: '',
      currDegrees:        [],
      currDisciplines:    [],

      result:           [],
      count:            0,
      initLoad:         true,
      isDegreeDisabled: true,

      //showLightbox:       false,
      showAlertbox:         false,

      placeholderText:  'Select discipline/s',
      searchResultName: 'Units',
      //lightboxType:       'Degrees',
      comparedUnits:     []
    };

    // do the first filter
    let options = {
      units:              this.state.units,
      currDegrees:        this.state.currDegrees,
      avaiDegrees:        this.state.avaiDegrees,
      currDisciplines:    this.state.currDisciplines,
      currClassification: this.state.currClassification,
      currOffering:       this.state.currOffering
    };

    let preSelected = this._getPreSelected(this.state.degrees, this.state.disciplines);


    options.currClassification = preSelected.classification;
    options.currDegrees = preSelected.currDegrees;
    options.currDisciplines = preSelected.currDisciplines;

    if(options.currClassification.length > 0){
      this.state.currClassification = options.currClassification;
    }

    if(options.currDegrees.length > 0){
      this.state.currDegrees = options.currDegrees;
      this.state.isDegreeDisabled = false;
    }

    if(options.currDisciplines.length > 0){
      this.state.currDisciplines = options.currDisciplines;
    }

    // fire first filter
    this.state.result = this._filterAllUnits(options);
  }

  componentDidMount() {
    // read localStorage
    this.dispatchReducer({type: 'UNIT_COMPARE::INIT'});

    // set last visit path
    if (localStorage) {
      localStorage.setItem('last_visited_path', "all-units");
    }
  }

  render() {

    return <div id="App_content" className="application">

      <div className="app-sub-nav-wrapper all-units-filter desktop-only">

          <div className="sq-form-control clearfix hidden">
             <input type="Submit"
                    name="compare_units_submit"
                    value="View My Shortlist"
                    disabled={this.state.comparedUnits.length < 1}
                    className={this.state.comparedUnits.length >= 1 ?
                      'button type-2 btn-submit btn-submit-compare btn btn--full-width' : 'button type-2 btn-submit btn-submit-compare btn btn--full-width is-disabled'}
                    onClick={this._doComparison} />
          </div>
          <AUFilter disciplines={this.state.disciplines}
                    degrees={this.state.degrees}
                    avaiDegrees={this.state.avaiDegrees}
                    classifications={this.state.classifications}
                    offerings={this.state.offerings}
                    currDisciplines={this.state.currDisciplines}
                    currDegrees={this.state.currDegrees}
                    currClassification={this.state.currClassification}
                    currOffering={this.state.currOffering}
                    initLoad={this.state.initLoad}
                    isDegreeDisabled={this.state.isDegreeDisabled}
                    count={this.state.count}
                    placeholderText = {this.state.placeholderText}
                    searchResultName = {this.state.searchResultName}
                    dispatchReducer={this.dispatchReducer} />

      </div>

      <div className="main-content">
        <div className="content">

          <div className="asset-content"
               dangerouslySetInnerHTML={{__html: this._decodeHtmlData(this.state.options.page_description)}} />

          <div className="filter-wrap all-units-filter-wrapper mobile-only clearfix">
              <h2 className="title">Filters</h2>
              <span className="icon__expand"></span>
          </div>

          <div className="app-sub-nav-wrapper all-units-filter mobile-only">

          </div>

          <div className="sq-form-control clearfix mobile-only hidden">
             <input type="Submit"
                    name="compare_units_submit"
                    value="View My Shortlist"
                    disabled={this.state.comparedUnits.length < 1}
                    className={this.state.comparedUnits.length >= 1 ?
                      'button type-2 btn-submit btn-submit-compare btn btn--full-width' : 'button type-2 btn-submit btn-submit-compare btn btn--full-width is-disabled'}
                    onClick={this._doComparison} />
          </div>

          <AUnits result={this.state.result}
                  options={this.state.options}
                  initLoad={this.state.initLoad}
                  count={this.state.count}
                  searchResultName = {this.state.searchResultName}
                  comparedUnits={this.state.comparedUnits}
                  dispatchReducer={this.dispatchReducer} />

                <div className="sq-form-control clearfix hidden">
            <input type="Submit"
              name="compare_units_submit"
              value="View My Shortlist"
              disabled={this.state.comparedUnits.length < 1}
              className={this.state.comparedUnits.length >= 1 ?
                'button type-2 btn-submit btn-submit-compare btn' : 'button type-2 btn-submit btn-submit-compare btn is-disabled'}
              onClick={this._doComparison} />

            <a href="#"
               className="all-units-remove-all"
               onClick={this._openAlertbox}>Clear shortlist</a>

          </div>
        </div>

        {this.state.showAlertbox ? <Alertbox data={{
            heading:  'Remove all units from shortlist',
            message:  'Are you sure you want to remove all units?'
          }} dispatchReducer={this.dispatchReducer} yesFunc={this.clearComparison} /> : null}

      </div>

    </div>;
  }

  _doComparison(e) {
    e.preventDefault();
    console.log(this.state.options);
    window.location = this.state.options.url_compare;
  }

  clearComparison() {
    let actions = [
      { type: 'UNIT_COMPARE::CLEAR' },
      { type: 'ABOX::CLOSE'}
    ];
    this.dispatchReducer(actions);

    // remove container's z-index from override everything
    this._$changeZIndex($('#main-wrapper'), '');
  }

  _openAlertbox(e) {
    e.preventDefault();

    this.dispatchReducer({
      type: 'ABOX::OPEN'
    });

    this._$changeZIndex($('#main-wrapper'), 10000);
  }

  dispatchReducer(action) {

    let newState = _.merge({}, this.state);

    if (_.isArray(action)) {
      for (let i = 0, len = action.length; i < len; i++) {
        newState = this._reducer(newState, action[i]);
      }

    } else {
      newState = this._reducer(newState, action);
    }

    if (action.fireFilter || _.some(action, ['fireFilter', true])) {
      const options = {
        units:              newState.units,
        currDisciplines:    newState.currDisciplines,
        currDegrees:        newState.currDegrees,
        currClassification: newState.currClassification,
        currOffering:       newState.currOffering,
        unitsCount:         newState.options.units_limit
      };

      newState = this._reducer(newState, {
        type: 'INIT::REMOVE'
      });

      newState = this._reducer(newState, {
        type:  'RESULT_ALL_UNITS::UPDATE',
        value: options
      });

      newState = this._reducer(newState, {
        type: 'ALL_UNITS_COUNT::UPDATE'
      });
    }

    this.setState(newState);
  }
}

AppAllUnits.propTypes = {
  data:    React.PropTypes.object.isRequired,
  options: React.PropTypes.object
};

export default AppAllUnits;
